// extracted by mini-css-extract-plugin
export default {"gallery":"carousel_gallery__tE+JL"};